import React, { useEffect } from "react";
import { Box, Typography, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useUrlParams } from "hooks/useUrlParams";
import AppLayout from "../components/AppLayout";
import { useTheme } from "@emotion/react";

// NewsItem component
const NewsItem = ({ newsItem, isLast, onClick }) => {
  return (
    <React.Fragment>
      <Divider sx={(theme) => ({ ...theme.components.divider })} />
      <Box
        onClick={newsItem.url ? () => onClick(newsItem.url) : undefined}
        sx={{
          paddingY: 1.5,
          paddingX: 0.5,
          cursor: newsItem.url ? "pointer" : "default",
          textAlign: "center",
          "&:hover": {
            backgroundColor: newsItem.url
              ? "rgba(255, 255, 255, 0.1)"
              : "transparent",
          },
        }}
      >
        <Typography
          sx={(theme) => ({
            marginBottom: 1,
            ...theme.components.newsItem.text.title,
          })}
        >
          {newsItem.title}
        </Typography>
        <Typography
          sx={(theme) => ({
            ...theme.components.newsItem.text.date,
          })}
        >
          {newsItem.date}
        </Typography>
      </Box>
      {isLast && <Divider sx={(theme) => ({ ...theme.components.divider })} />}
    </React.Fragment>
  );
};

function News() {
  const { work } = useUrlParams();
  const { t } = useTranslation(["common", work]);
  const theme = useTheme();

  const newsItems = t(`${work}:NewsItems`, { returnObjects: true });

  // Sort news items by date (newest first)
  const sortedNewsItems = newsItems
    ? [...newsItems].sort((a, b) => b.date.localeCompare(a.date))
    : [];

  const handleNewsClick = (url) => {
    if (url) {
      window.open(url, "_blank");
    }
  };

  // 初回ロード時
  useEffect(() => {}, []);

  return (
    <AppLayout page="News">
      <Box
        sx={{
          display: "flex",
          paddingTop: 4,
          paddingBottom: 4,
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 1,
            marginBottom: 4,
          }}
        >
          <Typography sx={(theme) => ({ ...theme.components.pageHeader })}>
            News
          </Typography>
        </Box>

        <Box sx={{ width: "100%", maxWidth: 600 }}>
          {sortedNewsItems &&
            sortedNewsItems.map((newsItem, index) => (
              <NewsItem
                key={index}
                newsItem={newsItem}
                isLast={index === sortedNewsItems.length - 1}
                onClick={handleNewsClick}
              />
            ))}
        </Box>
      </Box>
    </AppLayout>
  );
}

export default News;
